import { cssUtil } from "../../utils/cssUtil.js";
import { getBaseStyles } from "../commonStyles.js";

export async function renderFormWidget(context, widget, parent, override = null) {

    // <div class="widget form_widget">
    const el = context.document.createElement("div");
    el.classList.add("widget", "form_widget");
    const breakpoint = context.currentBreakpoint;

    const styles = getFormStyles(widget, breakpoint);
    el.setAttribute("style", cssUtil.toStyleString(styles));
    el.setAttribute("data-widgetId", widget.uid);
    el.setAttribute("data-widgetType", widget.type);
    el.setAttribute("data-widgetParent", widget.parent);

    parent.appendChild(el);

    // Render only first child (form step)
    const children = context.widgets.filter(w => w.parent === widget.uid);
    if (!children || !children.length) return el;

    for (let i = 0; i < children.length; i++) {
        const child = children[i];
    
        const device = child?.properties?.[breakpoint];
        if (device?.visible === false) continue;
    
        const renderer = context.renderers[child.type];
        if (!renderer) continue;
    
        const childOverride = i === 0 ? null : true;
    
        await renderer(context, child, el, childOverride);
    }

    return el;
}

function getFormStyles(widget, breakpoint) {
    const styles = {
        ...getBaseStyles(widget, breakpoint)
    };

    const props = widget?.properties?.desktop;
    if (!props) return styles;

    // Background
    if (props.background) {
        if (props.background.type === "solid") {
            styles["background-color"] = cssUtil.getCssColor(props.background);
        }
        if (props.background.type === "gradient") {
            styles["background-image"] = cssUtil.getCssGradient(props.background);
        }
    }

    // Border
    applyFormBorderStyles(styles, props);

    return styles;
}

function applyFormBorderStyles(styles, props) {
    const border = props.border;
    if (!border) return;

    // Radius
    if (border.radius) {
        const r = border.radius;
        if (r.topLeft) styles["border-top-left-radius"] = `${r.topLeft}px`;
        if (r.topRight) styles["border-top-right-radius"] = `${r.topRight}px`;
        if (r.bottomRight) styles["border-bottom-right-radius"] = `${r.bottomRight}px`;
        if (r.bottomLeft) styles["border-bottom-left-radius"] = `${r.bottomLeft}px`;
    }

    // Color
    if (border.color) {
        if (border.color.type === "solid") {
            styles["border-color"] = cssUtil.getCssColor(border.color);
        }
        if (border.color.type === "gradient") {
            // Matches Java's border-image behavior
            styles["border-image"] = cssUtil.getCssGradient(border.color);
            styles["border-image-slice"] = 1;
        }
    }

    // Width
    if (border.width !== undefined && border.width !== null) {
        styles["border-width"] = `${border.width}px`;
        styles["border-style"] = "solid";
    }
}